import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { Size } from 'type/size'

type Props = {
  size: Size
}

export const SizeTile = observer(({ size }: Props) => {
  const { tablet } = store.frame

  return <Vertical gap={12} opposite>
    <Typo one size={16}>
      {i18n('YourSize')}
    </Typo>
    <Typo size={tablet ? 32 : 48} one nowrap semi>
      {size.name}
    </Typo>
  </Vertical>
})
